module.exports = __webpack_public_path__ + "img/微雨医美.eddc521.png";